import { FunctionComponent, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { handlingUrlParams } from "../../Utils/AppUtils";
import AppsService from "services/application-service";

interface ApplicationsProps {}

const Applications: FunctionComponent<ApplicationsProps> = () => {
  const [appsData, setAppsData] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [lazyParams, setLazyParams] = useState({
    first: 1,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
  });

  useEffect(() => {
    loadLazyData();
  }, [lazyParams]);

  const loadLazyData = () => {
    setLoading(true);
    AppsService.getApps(
      handlingUrlParams({
        PageNumber: lazyParams.page,
        PageSize: lazyParams.rows,
      })
    )
      .then((response: any) => {
        const getHeaders = response.headers;
        const parsedHeaders = JSON.parse(getHeaders["x-pagination"]);
        console.log(parsedHeaders);
        setAppsData(response.data);
        setTotalRecords(parsedHeaders.TotalCount);
        setLoading(false);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };

  const onPage = (event: any) => {
    event["first"] = 0;
    event["page"] = event.page + 1;
    setLazyParams(event);
  };

  const onSort = (event: any) => {
    setLazyParams(event);
    console.log(event);
  };

  return (
    <>
      <DataTable
        className="shadow-md"
        scrollable
        scrollHeight="400px"
        value={appsData}
        loading={loading}
        stripedRows
        lazy={true}
        paginator={true}
        filterDisplay="menu"
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        dataKey="id"
        rowsPerPageOptions={[10, 20, 50]}
        emptyMessage="No Billing Codes found."
        totalRecords={totalRecords}
        rows={lazyParams.rows}
        onPage={onPage}
        onSort={onSort}
        sortOrder={lazyParams.sortOrder}
      >
        <Column field="id" header="id"></Column>
        <Column field="name" header="Name"></Column>
        <Column field="description" header="Description"></Column>
      </DataTable>
    </>
  );
};

export default Applications;
